import { Injectable } from '@angular/core';
import { IEnvironment } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
  })
export class EnvironmentService {
    static environment: IEnvironment;
    static customer:string;
    static isOneIdentity:boolean = false;

    load() {
      let configString = window.localStorage.getItem('puzzel_config');

      //Check if the standalone environment is loaded
      if (Object.prototype.hasOwnProperty.call(environment, 'standalone') && environment['standalone'] === true) {
        environment['getAccessToken']();
        configString = window.localStorage.getItem('puzzel_config');

      };

      if(configString == null){
          console.error("There is no settings in the localStorage!");
          let path = window.location.pathname.toLocaleLowerCase().indexOf('/admin') == 0 ? "admin/Account/Logon" : "Account/Logon";
          window.location.href = `${window.location.protocol}//${window.location.hostname}/${path}`;
      }
      EnvironmentService.environment = JSON.parse(configString);

      let refreshTokenString = window.localStorage.getItem('puzzel_refreshToken');
      let editCustomer = window.localStorage.getItem('puzzel_editCustomerKey');
      let customer  = "";
      if(refreshTokenString != null){
        customer = JSON.parse(refreshTokenString)?.CustomerKey;
      }
      EnvironmentService.customer = editCustomer || customer || "";
      EnvironmentService.isOneIdentity = window.localStorage.getItem('puzzel_oneIdentity')=="1";
    }
}
